import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export type AuditAction =
  | 'USER_DEACTIVATED'
  | 'USER_REACTIVATED'
  | 'USER_ROLE_CHANGED'
  | 'USER_PASSWORD_RESET_ISSUED'
  | 'USER_INVITED'
  | 'USER_INVITE_ACCEPTED'
  | 'ROLE_CREATED'
  | 'ROLE_UPDATED'
  | 'ROLE_DELETED'
  | 'COMPANY_CREATED'
  | 'COMPANY_UPDATED'
  | 'COMPANY_DEACTIVATED'
  | 'COMPANY_REACTIVATED'
  | 'DRIVER_CREATED'
  | 'DRIVER_UPDATED'
  | 'DRIVER_DEACTIVATED'
  | 'DRIVER_REACTIVATED'
  | 'VEHICLE_CREATED'
  | 'VEHICLE_UPDATED'
  | 'VEHICLE_DEACTIVATED'
  | 'VEHICLE_REACTIVATED'
  | 'FREIGHT_CREATED'
  | 'FREIGHT_UPDATED'
  | 'FREIGHT_FINANCE_UPDATED'
  | 'FREIGHT_ASSIGNED'
  | 'FREIGHT_STARTED'
  | 'FREIGHT_DELIVERED'
  | 'FREIGHT_PROOF_RECEIVED'
  | 'FREIGHT_COMPLETED'
  | 'INVOICE_CREATED'
  | 'INVOICE_UPDATED'
  | 'INVOICE_DELETED'
  | 'INVOICE_PAYMENT_CREATED'
  | 'REPAYMENT_UPDATED'
  | 'REPAYMENT_PAID'
  | 'CASH_ACCOUNT_CREATED'
  | 'CASH_ACCOUNT_UPDATED'
  | 'CASH_ACCOUNT_DEACTIVATED'
  | 'CASH_ACCOUNT_REACTIVATED'
  | 'CASH_CATEGORY_CREATED'
  | 'CASH_CATEGORY_UPDATED'
  | 'CASH_CATEGORY_DEACTIVATED'
  | 'CASH_CATEGORY_REACTIVATED'
  | 'CASH_TRANSACTION_CREATED'
  | 'CASH_TRANSACTION_TRANSFER'
  | 'CASH_TRANSACTION_REVERSED'
  | 'EMPLOYEE_CREATED'
  | 'EMPLOYEE_UPDATED'
  | 'EMPLOYEE_TERMINATED'
  | 'EMPLOYEE_REACTIVATED'
  | 'SALARY_PAYMENT_CREATED'
  | 'OPERATIONAL_EXPENSE_CREATED'
  | 'FINANCIAL_OBLIGATION_CREATED'
  | 'FINANCIAL_OBLIGATION_UPDATED'
  | 'FINANCIAL_OBLIGATION_PAID'
  | 'FINANCIAL_OBLIGATION_CANCELED'

export interface AuditLogEntry {
  id: string
  action: AuditAction
  actorUserId: string | null
  actorStaffUserId: string | null
  actorName: string
  targetType: string
  targetId: string
  targetLabel: string | null
  metadata: Record<string, unknown> | null
  createdAt: string
}

export interface PaginatedAuditLogs {
  data: AuditLogEntry[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

export interface ListAuditLogParams {
  action?: AuditAction
  targetType?: string
  from?: string
  to?: string
  page?: number
  perPage?: number
}

export function useAuditLogs(params: ListAuditLogParams = {}) {
  return useQuery({
    queryKey: ['audit-logs', params],
    queryFn: () =>
      api.get<PaginatedAuditLogs>('/audit-logs', { params }).then((r) => r.data),
  })
}
